import React, { useCallback, useContext, useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import _first from 'lodash/first';
import _get from 'lodash/get';
import { useHistory } from 'react-router-dom';
import { getPostOrderAccepted } from '@kfc-global/react-shared/redux/Actions/PostOrderAction';
import { setUserParams } from '@kfc-global/react-shared/redux/Actions/AppStateAction';
import { reorderFetchMenuAction } from '@kfc-global/react-shared/redux/Actions/ReorderAction';
import { getBulkStoreStatus, getStoreDetails } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  addItemToCartAction,
  createBasketsAction,
  resetBasketAction,
} from '@kfc-global/react-shared/redux/Actions/CartAction';
import ReorderComponentGlobal from '../Presentation/ReorderComponentGlobal';
import START_ORDER_CONSTANTS from 'organisms/StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from 'context/context';
import {
  convertTime,
  createBasketData,
  createPayloadForStatusCall,
  getAndCheck,
  getAndCheckIfOneTrue,
  getDispositionTypeOnAPIFormat,
  getFullAddressDetails,
  getValueOrDefaultObject,
  isEmptyEvery,
  safeUpperCase,
  triggerCartModel,
  getUserType,
  setDropOffAddress,
  getTernaryValue,
  checkAllTrue,
  isEmptyObject,
  getUpdatedPayloadInfo,
  getUpdatedStoreInfo,
  isSupportedTenantCode,
  isFutureDate,
  isFutureTime,
  calculatePrice,
} from 'common/utilities/utils';
import {
  ASAP_TIMING,
  CLOSED,
  LOCAL_STORAGE_KEYS,
  ROUTE_URL,
  ANALYTICS_SHARED_CONSTANTS,
  REORDER_CONSTANTS,
  DATE_FORMATS,
  SESSION_STORAGE_KEYS,
  DISPOSITION_TYPES,
} from 'common/constants/SharedConstants';
import { FORM } from 'organisms/SearchStore/AU/Config/searchStore.config';
import {
  changedDeliveryAddress,
  getList,
  getDateTimeListScheduleOrder,
  dateTimeManipulation,
} from 'organisms/ScheduleOrder/ScheduleOrderUtils/ScheduleOrderUtils';
import { ChannelManager } from 'common/manager';
import {
  dateIsBetween,
  currentDateTimeInFormat,
  getCurrentDateTimeInUnix,
  formatDateTime,
} from 'common/utilities/dayJsUtils';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { reOrderAddToCartAnalytic, reOrderAnalytic } from 'organisms/AccountPage/AU/accountPageUtils';
import { geocodeByAddress } from 'react-places-autocomplete';
import { resetMenuFulfillmentData } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { convertTimeString } from 'organisms/SearchStore/AU/SearchStoreUtilities/SearchStoreUtils';

export const dispatchAddToCartFunc = payload => {
  const {
    dispatch,
    response,
    foodLineInfo,
    basketId,
    tenantId,
    updateReorderDetails,
    setupLocalization,
    storeDetail,
    orderinfoData,
    closeButtonHandler,
  } = payload;
  if (response.unAval !== foodLineInfo.length) {
    dispatch(
      addItemToCartAction(
        {
          params: {
            basketId,
          },
          tenantId,
        },
        response.itemArr,
        _successCallback => {
          setupLocalization(storeDetail, orderinfoData);
          updateReorderDetails({ confirmed: true });
          closeButtonHandler();
        },
      ),
    );
  }
};
export const setStoreClosedErrorMessage = setClosedStoreMsgPayload => {
  const { enableScheduleOrder, isFutureTimeOrderAvailable, updateReorderDetails, storename, service } =
    setClosedStoreMsgPayload;
  const { STORE_CLOSED_ERROR, STORE_CLOSED_NEXT_TIME_APPLIED_PICKUP_MSG, STORE_CLOSED_NEXT_TIME_APPLIED_DELIVERY_MSG } =
    TRANSLATE_MAPPING_KEY;
  enableScheduleOrder && isFutureTimeOrderAvailable
    ? updateReorderDetails({
        storeError: null,
        storeClosedError:
          safeUpperCase(service) === DISPOSITION_TYPES.PICKUP
            ? translateWithI18Next(STORE_CLOSED_NEXT_TIME_APPLIED_PICKUP_MSG)
            : translateWithI18Next(STORE_CLOSED_NEXT_TIME_APPLIED_DELIVERY_MSG),
      })
    : updateReorderDetails({
        storeClosedError: null,
        storeError: translateWithI18Next(STORE_CLOSED_ERROR)?.replace(
          '$storeName',
          `<b class="item-desc-bold">${storename}</b>`,
        ),
      });
};
export const checkProductPriceAndAvail = (id, productList) => {
  const scheduledTime = currentDateTimeInFormat(DATE_FORMATS.lll);
  const product = productList?.filter(products => products?.id === id) || {};
  const availableHours = product[0]?.availability[0]?.availableHours;
  const startTime = availableHours?.startTime?.time;
  const endTime = availableHours?.endTime?.time;
  const startingTime = convertTimeString(convertTime(startTime), DATE_FORMATS.lll);
  const endingTime = convertTimeString(convertTime(endTime), DATE_FORMATS.lll);
  const isAvailableProduct = dateIsBetween(scheduledTime, startingTime, endingTime);
  const hiddenItem = product[0]?.isHidden;
  if (hiddenItem) {
    return { isAvailable: 'hidden', product };
  }
  return { isAvailable: isAvailableProduct, product };
};
const isAsapOrderFlag = storeDetails => {
  const { timings = {}, orderingAttribute = {} } = getValueOrDefaultObject(storeDetails?.[0]?.summary);
  const { asap = {} } = timings;
  const { isAsapOrder = false } = orderingAttribute;
  const isStoreClosed = !asap?.isAvailable;
  const asapOrderFlag = !isStoreClosed && isAsapOrder;
  return Boolean(asapOrderFlag);
};
const isSchduleOrderFlow = isSchduleOrderFlowObj => {
  const { storeClosedError, isFutureDateTimeOrder, scheduleOrderFlag, changeScheduleOrder, enabledDate } =
    isSchduleOrderFlowObj;
  return Boolean(!storeClosedError && isFutureDateTimeOrder && scheduleOrderFlag && changeScheduleOrder && enabledDate);
};
const isStoreClosedNextTimeAppliedFlow = isStoreClosedNextTimeAppliedFlowObj => {
  const {
    storeClosedError,
    asapOrderFlag,
    isFutureDateTimeOrder,
    changeScheduleOrder,
    enabledDate,
    isDateTimeSelected,
  } = isStoreClosedNextTimeAppliedFlowObj;
  return Boolean(
    (storeClosedError || !asapOrderFlag) &&
      isFutureDateTimeOrder &&
      !changeScheduleOrder &&
      enabledDate &&
      !isDateTimeSelected,
  );
};
const isToggleOnOrderScheduling = (enableScheduleOrder, storeDetails) => Boolean(enableScheduleOrder && storeDetails);
const setOrderSchedulingFlag = (asapOrderFlag, isFutureDateTimeOrder, enabledDate) =>
  Boolean(asapOrderFlag && isFutureDateTimeOrder && enabledDate);
const IsEnableChangeButton = (isFutureTimeOrderAvailable, changeScheduleOrder, enabledDate) =>
  Boolean(isFutureTimeOrderAvailable && !changeScheduleOrder && enabledDate);
const isWholeDayShutdown = (storeClosedFlag, enabledDate) => Boolean(storeClosedFlag && !enabledDate);
const saveScheduleDate = fetchMenuPayload => ({
  ...fetchMenuPayload,
  startDateInEpoch: +sessionStorage?.getItem(SESSION_STORAGE_KEYS?.SCHEDULE_DATE_EPOCH),
});

export const getEnableAllowScheduleOrder = (
  enableClickCollectScheduleOrder,
  allowScheduleOrderForDispositions,
  modifiedService,
) => enableClickCollectScheduleOrder && allowScheduleOrderForDispositions?.includes(modifiedService);

export const getEnableScheduleOrder = (enableScheduleOrder, enableClickCollectScheduleOrderFlag) =>
  enableScheduleOrder || enableClickCollectScheduleOrderFlag;

export const getTodayASAPText = enableClickCollectScheduleOrderFlag =>
  enableClickCollectScheduleOrderFlag
    ? translateWithI18Next(TRANSLATE_MAPPING_KEY.TODAY_ASAP)
    : translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)?.toUpperCase();

export const getUpdatedScheduleOrder = (
  reorderDetails,
  asapOrderFlag,
  updateReorderDetails,
  enableClickCollectScheduleOrderFlag,
) =>
  reorderDetails?.orderNowFlag &&
  asapOrderFlag &&
  updateReorderDetails({
    orderSchedulingMode: enableClickCollectScheduleOrderFlag
      ? translateWithI18Next(TRANSLATE_MAPPING_KEY.TODAY_ASAP)
      : translateWithI18Next(TRANSLATE_MAPPING_KEY.ASAP)?.toUpperCase(),
  });

const ReorderContainerGlobal = props => {
  const { currentOrderInfo, reorderModalOpen, closeButtonHandler, source } = props;
  const { service, id: orderId, store: storeData, name: orderName } = getValueOrDefaultObject(currentOrderInfo);
  const { storeId: orderStoreId } = getValueOrDefaultObject(storeData);
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    RESET_DELIVERY_ADDRESS_LINE,
    DISPOSITION_DATA,
    SCHEDULE_ORDER_DATA,
    SEARCH_ORDER_DATA,
    DISPOSITION_METHOD,
    USER_LOCALIZED,
    CURRENT_STORE_INFO,
    SET_DISPOSITION,
    SCHEDULE_ORDER_TIME_DATA,
    REORDER_MODAL_OPEN,
    SET_ASAP_SCHEDULING,
    SCHEDULE_ORDER_CLICKED,
  } = START_ORDER_CONSTANTS;
  const {
    DISPOSITION_NEW,
    DISPOSITION_OLD,
    DISPOSITION_TYPE,
    DATE_TIME_ORDER,
    SELECTED_TILE,
    CONFIG_SEARCH_SCREEN,
    CURRENT_STORE_INFO_STORAGE,
    STORE_INFO
  } = LOCAL_STORAGE_KEYS;

  const { ORDER_TYPE_DIFFERENT_ERROR, LOCATION_DIFFERENT_ERROR, STORE_CLOSED_ERROR } = TRANSLATE_MAPPING_KEY;

  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  let {
    dispositionNew,
    reorderFlag: { storeChanged = false },
    currentStoreInfo = {},
    scheduleOrderData = {},
    showOrderNowReorder: showOrderNow = false,
    showScheduleOrderReorder: showScheduleOrder = false,
    scheduleModeClicked = false,
  } = userOrderState;
  const { changeFlow = false, isAddressFlow = false } = scheduleOrderData;
  dispositionNew = getTernaryValue(
    isEmptyEvery(dispositionNew),
    JSON.parse(localStorage.getItem(DISPOSITION_NEW)),
    dispositionNew,
  );

  const userParams = useSelector(data => data?.appStateReducer?.userStatus);
  const { localized = false, loggedIn = false } = getValueOrDefaultObject(userParams);
  const userType = getUserType(localized, loggedIn);
  const tenantReducer = useSelector(data => data?.tenantReducer);
  const { tenantId, currencyConversionFactor, currencySymbol, componentOptions } =
    getValueOrDefaultObject(tenantReducer);
  const { web = {} } = componentOptions;
  const { shouldCheckDropOffAddress = false } = web;
  const profileReducer = useSelector(data => data?.profileReducer);
  const { customerId } = getValueOrDefaultObject(profileReducer);

  const postOrderReducer = useSelector(data => data?.postOrderReducer);
  const { orderAccepted: orderDetails = {} } = getValueOrDefaultObject(postOrderReducer);

  const reorderReducer = useSelector(data => data?.reorderReducer);
  const { flatResponse } = getValueOrDefaultObject(reorderReducer);
  const { items: flatResItems = [] } = getValueOrDefaultObject(flatResponse);

  const cartReducer = useSelector(data => data?.cartReducer);
  const isPastOrderValidationLoading = useSelector(
    data =>
      data.postOrderReducer?.orderAcceptedLoading ||
      data.storesReducer?.isStoreDetailsLoading ||
      data.LoaderReducer?.isLoading,
  );
  const { cartData, isAddItemLoading, currentItemId } = getValueOrDefaultObject(cartReducer);
  const { discountLines = [], foodLines = [] } = orderDetails;
  const len = getAndCheck(discountLines, discountLines?.length - 1);
  const discountLinesObj = getAndCheck(discountLines, discountLines[len]);
  const { couponCode = '', amount = '' } = getValueOrDefaultObject(discountLinesObj);
  const discountAmount = calculatePrice(amount, currencyConversionFactor);
  const dispositionConfig = componentOptions?.web?.dispositionConfig;
  const { enableScheduleOrder = false } = dispositionConfig;

  const { modifiedService } = getUpdatedStoreInfo(storeChanged, currentStoreInfo, currentOrderInfo);
  const enableClickCollectScheduleOrder = componentOptions?.web?.dispositionConfig?.enableClickCollectScheduleOrder;
  const allowScheduleOrderForDispositions = componentOptions?.web?.scheduledDelivery?.allowScheduleOrderForDispositions;
  const enableClickCollectScheduleOrderFlag = getEnableAllowScheduleOrder(
    enableClickCollectScheduleOrder,
    allowScheduleOrderForDispositions,
    modifiedService,
  );
  const enableScheduleOrderFlag = getEnableScheduleOrder(enableScheduleOrder, enableClickCollectScheduleOrderFlag);
  const reorderDetailsDefaultValue = {
    unavailableItem: [],
    showModal: reorderModalOpen,
    orderTypeDifferentError: null,
    locationDifferentError: null,
    storeDetail: null,
    storeError: null,
    confirmed: false,
    orderinfoData: {},
    isLocalizationSetup: false,
    enableButton: false,
    orderNowFlag: true,
    scheduleOrderFlag: false,
    changeScheduleOrder: false,
    dateTimeArr: [],
    selectedDate: {},
    selectedTime: {},
    orderSchedulingMode: getTodayASAPText(enableClickCollectScheduleOrderFlag),
    isFutureDateTimeOrder: false,
    isMenuFetched: false,
    hasError: { error: false, errormessage: '' },
    storeClosedError: null,
    enableSceduleCA: false,
    isFlowChangedLoadingFinish: false,
  };
  const [reorderDetails, setReorderDetails] = useState(reorderDetailsDefaultValue);

  const updateReorderDetails = useCallback(param => {
    setReorderDetails && setReorderDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  const { YYYY_MM_DD } = DATE_FORMATS;
  const isFlowChanged = enableScheduleOrderFlag ? storeChanged : changeFlow;
  useEffect(() => {
    const isToggleOnOrderSchedulingFlag = isToggleOnOrderScheduling(
      enableScheduleOrderFlag,
      reorderDetails.storeDetail,
    );
    if (isToggleOnOrderSchedulingFlag && reorderDetails.isFutureDateTimeOrder && !reorderDetails.changeScheduleOrder) {
      const dateTimeScheduleOrderObj = {
        displayStoreInfo: reorderDetails.storeDetail?.[0],
        enableScheduleOrder: enableScheduleOrderFlag,
        enableClickCollectScheduleOrderFlag,
        fromReorder: true,
        scheduleModeClicked,
      };
      const dateTimeSlots = getDateTimeListScheduleOrder(dateTimeScheduleOrderObj);
      updateReorderDetails({ dateTimeArr: dateTimeSlots });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enableScheduleOrder,
    reorderDetails.storeDetail,
    service,
    storeChanged,
    reorderDetails.isFutureDateTimeOrder,
    reorderDetails.changeScheduleOrder,
  ]);

  useEffect(() => {
    const isToggleOnOrderSchedulingFlag = isToggleOnOrderScheduling(
      enableScheduleOrderFlag,
      reorderDetails.storeDetail,
    );
    if (
      isToggleOnOrderSchedulingFlag &&
      reorderDetails.isFutureDateTimeOrder &&
      reorderDetails.scheduleOrderFlag &&
      reorderDetails.changeScheduleOrder
    ) {
      const dateTimeManupulationObj = {
        shouldShowScheduleOrder: reorderDetails.scheduleOrderFlag,
        store: reorderDetails.storeDetail,
        updateReorderDetails: updateReorderDetails,
        changeFlow,
        enableScheduleOrder: enableScheduleOrderFlag,
        selectedDate: reorderDetails.selectedDate,
        selectedTime: reorderDetails.selectedTime,
        service,
        fromReorder: true,
        scheduleModeClicked,
        enableClickCollectScheduleOrderFlag,
      };
      dateTimeManipulation(dateTimeManupulationObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enableScheduleOrderFlag,
    reorderDetails.scheduleOrderFlag,
    storeChanged,
    reorderDetails.storeDetail,
    reorderDetails.isFutureDateTimeOrder,
    reorderDetails.changeScheduleOrder,
  ]);

  useEffect(() => {
    const isToggleOnOrderSchedulingFlag = isToggleOnOrderScheduling(
      enableScheduleOrderFlag,
      reorderDetails.storeDetail,
    );
    if (isToggleOnOrderSchedulingFlag) {
      const asapOrderFlag = isAsapOrderFlag(reorderDetails?.storeDetail);
      const enabledDate = reorderDetails.dateTimeArr?.find(item => !item?.date?.disabled);
      const isDateTimeSelected = !isEmpty(reorderDetails.selectedDate) && !isEmpty(reorderDetails.selectedTime);
      const storename = _get(reorderDetails?.storeDetail[0]?.summary, 'name', {});
      const isWholeDayShutdownFlag = isWholeDayShutdown(reorderDetails?.storeClosedError, enabledDate);

      getUpdatedScheduleOrder(reorderDetails, asapOrderFlag, updateReorderDetails, enableClickCollectScheduleOrderFlag);
      const isStoreClosedNextTimeAppliedFlowObj = {
        storeClosedError: reorderDetails?.storeClosedError,
        asapOrderFlag,
        isFutureDateTimeOrder: reorderDetails?.isFutureDateTimeOrder,
        changeScheduleOrder: reorderDetails.changeScheduleOrder,
        enabledDate,
        isDateTimeSelected,
      };
      const isStoreClosedNextTimeAppliedFlowFlag = isStoreClosedNextTimeAppliedFlow(
        isStoreClosedNextTimeAppliedFlowObj,
      );
      isStoreClosedNextTimeAppliedFlowFlag &&
        updateReorderDetails({
          scheduleOrderFlag: true,
          selectedDate: enabledDate,
          selectedTime: enabledDate?.timeSlots[0],
          orderNowFlag: false,
        });
      const isSchduleOrderFlowObj = {
        storeClosedError: reorderDetails.storeClosedError,
        isFutureDateTimeOrder: reorderDetails.isFutureDateTimeOrder,
        scheduleOrderFlag: reorderDetails.scheduleOrderFlag,
        changeScheduleOrder: reorderDetails.changeScheduleOrder,
        enabledDate,
      };
      const isSchduleOrderFlowFlag = isSchduleOrderFlow(isSchduleOrderFlowObj);
      isSchduleOrderFlowFlag &&
        isEmpty(reorderDetails.selectedDate) &&
        updateReorderDetails({ selectedDate: enabledDate });
      isWholeDayShutdownFlag &&
        updateReorderDetails({
          storeClosedError: null,
          storeError: translateWithI18Next(STORE_CLOSED_ERROR)?.replace(
            '$storeName',
            `<b class="item-desc-bold">${storename}</b>`,
          ),
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enableScheduleOrderFlag,
    reorderDetails.orderNowFlag,
    reorderDetails.scheduleOrderFlag,
    reorderDetails.storeClosedError,
    reorderDetails.changeScheduleOrder,
    reorderDetails.storeDetail,
    reorderDetails.isFutureDateTimeOrder,
    storeChanged,
    reorderDetails.dateTimeArr,
  ]);

  useEffect(() => {
    if (enableScheduleOrderFlag && !isEmpty(reorderDetails.selectedDate) && !isEmpty(reorderDetails.selectedTime)) {
      const date = reorderDetails.selectedDate.date.value;
      const time = reorderDetails.selectedTime.value;
      const dateTime = ` ${date}, ${time}`;
      updateReorderDetails({ orderSchedulingMode: dateTime });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reorderDetails.selectedDate, reorderDetails.selectedTime, enableScheduleOrderFlag]);

  useEffect(() => {
    const isToggleOnOrderSchedulingFlag = isToggleOnOrderScheduling(
      enableScheduleOrderFlag,
      reorderDetails.storeDetail,
    );
    if (isToggleOnOrderSchedulingFlag) {
      const enabledDate = reorderDetails.dateTimeArr?.find(item => !item?.date?.disabled);
      const isFutureTimeOrderAvailable =
        isFutureTime(reorderDetails.storeDetail?.[0]) || isFutureDate(reorderDetails.storeDetail?.[0]);
      const enableChangeButton = IsEnableChangeButton(
        isFutureTimeOrderAvailable,
        reorderDetails.changeScheduleOrder,
        enabledDate,
      );

      updateReorderDetails({
        isFutureDateTimeOrder: isFutureTimeOrderAvailable,
        enableSceduleCA: enableChangeButton,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enableScheduleOrderFlag, reorderDetails.storeDetail, storeChanged, reorderDetails.dateTimeArr]);

  useEffect(() => {
    if (reorderDetails?.showModal && enableScheduleOrderFlag && !storeChanged) {
      userOrderStateDispatch({ type: SCHEDULE_ORDER_CLICKED, value: { scheduleModeClicked: false } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reorderDetails?.showModal, enableScheduleOrderFlag, storeChanged]);
  useEffect(() => {
    const isToggleOnOrderSchedulingFlag = isToggleOnOrderScheduling(
      enableScheduleOrderFlag,
      reorderDetails.storeDetail,
    );
    if (
      isToggleOnOrderSchedulingFlag &&
      reorderDetails.showModal &&
      storeChanged &&
      !reorderDetails.isFlowChangedLoadingFinish
    ) {
      const enabledDate = reorderDetails.dateTimeArr?.find(item => !item?.date?.disabled);
      const asapOrderFlag = isAsapOrderFlag(reorderDetails?.storeDetail);
      const isSetOrderSchedulingFlag = setOrderSchedulingFlag(
        asapOrderFlag,
        reorderDetails.isFutureDateTimeOrder,
        enabledDate,
      );
      isSetOrderSchedulingFlag &&
        updateReorderDetails({
          orderNowFlag: showOrderNow,
          changeScheduleOrder: !showOrderNow || (showScheduleOrder && reorderDetails.dateTimeArr?.length),
          scheduleOrderFlag: !showOrderNow || (showScheduleOrder && reorderDetails.dateTimeArr?.length),
          isFlowChangedLoadingFinish: true,
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enableScheduleOrderFlag,
    showOrderNow,
    showScheduleOrder,
    storeChanged,
    reorderDetails.showModal,
    reorderDetails.storeDetail,
    reorderDetails.dateTimeArr,
    reorderDetails.isFlowChangedLoadingFinish,
    reorderDetails.isFutureDateTimeOrder,
  ]);

  const enableScheduleMode = event => {
    updateReorderDetails({
      changeScheduleOrder: true,
      scheduleOrderFlag: true,
      orderNowFlag: false,
    });
  };
  const changeDateValue = selectedItem => {
    const filteredDateObj = reorderDetails.dateTimeArr?.find(item => item?.date?.key === selectedItem?.key);
    updateReorderDetails({
      hasError: {
        ...reorderDetails.hasError,
        error: false,
        errormessage: '',
      },
      selectedDate: filteredDateObj,
      storeError: null,
      storeClosedError: null,
      selectedTime: { ...filteredDateObj?.timeSlots?.[0] },
    });
  };
  const changeTimeValue = selectedItem => {
    updateReorderDetails({
      hasError: {
        ...reorderDetails.hasError,
        error: false,
        errormessage: '',
      },
      selectedTime: selectedItem,
      storeError: null,
      storeClosedError: null,
    });
  };

  useEffect(() => {
    if (getAndCheck(reorderDetails.confirmed, currentItemId)) {
      updateReorderDetails({ confirmed: false });
      history.push(ROUTE_URL.CART);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reorderDetails.confirmed, currentItemId]);

  const totalAmount = calculatePrice(orderDetails?.total, currencyConversionFactor);
  const onChangeDisposition = useCallback(() => {
    updateReorderDetails({ showModal: false });
    userOrderStateDispatch({
      type: RESET_DELIVERY_ADDRESS_LINE,
    });
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
    userOrderStateDispatch({ type: SCHEDULE_ORDER_DATA, value: { showScheduleOrder: false } });
    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userOrderStateDispatch]);

  const editDeliveryLocation = useCallback(
    addressLine => {
      const storeDetails = _first(reorderDetails.storeDetail, {});
      if (storeDetails) {
        userOrderStateDispatch({
          type: DISPOSITION_METHOD,
          value: { dispositionType: storeDetails.service },
        });
        changedDeliveryAddress(
          isAddressFlow,
          storeDetails,
          FORM,
          isFlowChanged,
          true,
          addressLine,
          userOrderStateDispatch,
        );
        userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [userOrderStateDispatch, isFlowChanged, isAddressFlow, reorderDetails.storeDetail],
  );

  const onChangeRestaurant = () => {
    const { modifiedStoreData, modifiedService: modifiedServiceInfo } = getUpdatedStoreInfo(
      storeChanged,
      currentStoreInfo,
      currentOrderInfo,
    );
    const storeDetails = _first(reorderDetails.storeDetail, {});
    if (storeDetails) {
      updateReorderDetails({ showModal: false });
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: storeDetails.service },
      });
      triggerCartModel(userOrderStateDispatch, storeDetails.summary?.name);
      userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
    } else {
      updateReorderDetails({ showModal: false });
      userOrderStateDispatch({
        type: DISPOSITION_METHOD,
        value: { dispositionType: modifiedServiceInfo },
      });
      triggerCartModel(userOrderStateDispatch, modifiedStoreData?.name);
      userOrderStateDispatch({ type: REORDER_MODAL_OPEN, value: { reorderModalOpen: false } });
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dateTimeObj = useCallback(storeDetails => {
    if (!isEmptyEvery(storeDetails)) {
      const { summary } = storeDetails;
      /* newly added code for order now logic */
      const { futureDates, scheduled: initiallyScheduled, asap } = getValueOrDefaultObject(summary?.timings);
      const { interval: initialInterval = 0, startEndTime = {} } =
        initiallyScheduled && initiallyScheduled.periods.length && initiallyScheduled.periods[0];
      const { from: initialDayStartTime, to: initialDayEndTime } = startEndTime;

      getList(
        initialDayStartTime,
        initialDayEndTime,
        initialInterval,
        asap?.isAvailable,
        getAndCheck(futureDates.length === 1, isSupportedTenantCode()),
      );
      return {
        time: ASAP_TIMING,
        interval: summary?.timings.scheduled.periods[0]?.interval,
        date: new Date(),
        selectedTime: ASAP_TIMING,
      };
    }
  });

  const getItemWithCustomisation = modGrps => {
    const modifiiedItem = modGrps;
    modGrps.forEach((newItem, index) => {
      modGrps[index].modifiers = newItem.modifiers?.filter(modifieritem => modifieritem.isAdded === true);
    });
    return modifiiedItem;
  };

  const checkAvailability = (foodLineInfo, flatResItemsData) => {
    const itemArr = [];
    let unAval = 0;
    let unavailableItem = [];
    foodLineInfo?.forEach(newItem => {
      const { isAvailable, product } = checkProductPriceAndAvail(newItem?.item?.id, flatResItemsData);
      if (isAvailable !== 'hidden') {
        if (!isAvailable) {
          unAval = unAval + 1;
          unavailableItem.push(newItem.item);
        } else {
          itemArr.push({
            Id: newItem.item.id,
            quantity: newItem.quantity,
            categoryUrl: product?.[0]?.categoryUrl?.[0],
            categoryName: product?.[0]?.categoryName,
            categoryId: product?.[0]?.categoryId,
            modGrps: getItemWithCustomisation(newItem?.item?.modGrps),
          });
        }
      }
    });
    updateReorderDetails({ unavailableItem: unavailableItem });
    return { unAval, itemArr };
  };

  const onClickOrderAgainHandler = async () => {
    const { deliveryAddress = null, service: serviceInfo } = getUpdatedPayloadInfo(reorderDetails.storeDetail);
    if (isEmptyObject(deliveryAddress)) {
      const deliveryAddressFormatted = getFullAddressDetails(deliveryAddress);
      const results = await geocodeByAddress(deliveryAddressFormatted);
      setDropOffAddress(serviceInfo, results);
    }

    localStorage.setItem(LOCAL_STORAGE_KEYS.SERVICE_TYPE, getDispositionTypeOnAPIFormat(serviceInfo));
    const currency = ANALYTICS_SHARED_CONSTANTS.AUD;
    let itemsArrayReorder = [];
    foodLines?.forEach((i, idx) => {
      let priceAmt = calculatePrice(i?.unitPrice, currencyConversionFactor);
      itemsArrayReorder.push({
        item_name: getAndCheckIfOneTrue(i?.item?.dname[0]?.value, 'NA'),
        item_id: getAndCheckIfOneTrue(i?.item?.id, 'NA'),
        price: getAndCheckIfOneTrue(parseFloat(priceAmt), 'NA'),
        coupon: couponCode,
        currency: currency,
        discount: discountAmount,
        item_category: i?.item?.categoryName || 'NA',
        item_list_name: source,
        item_list_id: '',
        index: idx + 0,
        quantity: getAndCheckIfOneTrue(i?.quantity, 'NA'),
      });
    });
    reOrderAddToCartAnalytic(itemsArrayReorder, userType, currency, totalAmount);
    if (foodLines.length > 0) {
      dispatch(resetBasketAction());
    }
    if (source === REORDER_CONSTANTS?.HOME_FAVOURITES) {
      reOrderAnalytic(userType, orderName);
    }
  };

  const fetchReorderMenu = (selectedCatalogName, selectedStoreId, selectedService) => {
    let fetchMenuPayload = { storeId: selectedStoreId, channel: ChannelManager.channel, service: selectedService };
    const updatedFetchMenuPayload = saveScheduleDate(fetchMenuPayload);
    console.log(" saveScheduleDate(fetchMenuPayload)", saveScheduleDate(fetchMenuPayload))
    resetMenuFulfillmentData();
    if (enableScheduleOrderFlag) {
      dispatch(
        reorderFetchMenuAction(
          {
            tenantId: tenantId,
            catalogName: selectedCatalogName, //catalogs
          },
          updatedFetchMenuPayload,
          () => updateReorderDetails({ isMenuFetched: true }),
        ),
      );
    } else {
      dispatch(
        reorderFetchMenuAction(
          {
            tenantId,
            catalogName: selectedCatalogName,
          },
          { storeId: selectedStoreId, channel: ChannelManager.channel, service: selectedService },
          () => updateReorderDetails({ isMenuFetched: true }),
        ),
      );
    }
  };

  useEffect(() => {
    if (checkAllTrue([foodLines.length > 0, flatResItems.length > 0, reorderDetails.isMenuFetched])) {
      const { id } = getValueOrDefaultObject(cartData);
      const response = checkAvailability(foodLines, flatResItems);
      const payload = {
        dispatch: dispatch,
        response: response,
        foodLineInfo: foodLines,
        basketId: id,
        tenantId: tenantId,
        updateReorderDetails: updateReorderDetails,
        setupLocalization: setupLocalization,
        storeDetail: reorderDetails.storeDetail,
        orderinfoData: reorderDetails.orderinfoData,
        closeButtonHandler: closeButtonHandler,
      };
      dispatchAddToCartFunc(payload);
      updateReorderDetails({ isMenuFetched: false });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [foodLines, flatResItems, reorderDetails.isMenuFetched]);

  const onClickOrderAgain = async () => {
    const { lang, catalog, storeId, deliveryAddress, storename, service: serviceInfo } = getUpdatedPayloadInfo(
      reorderDetails.storeDetail,
    );
    const address = storeChanged ? deliveryAddress : reorderDetails.orderinfoData?.deliveryAddress;
    const ScheduledDateTimeObj = {
      date: reorderDetails.selectedDate?.date?.key ?? formatDateTime(new Date(), YYYY_MM_DD),
      time: reorderDetails.selectedTime?.value ?? ASAP_TIMING,
      selectedTime: reorderDetails.selectedTime?.value ?? ASAP_TIMING,
    };
    const dateTimeObject = {
      time: ASAP_TIMING,
      date: new Date(),
      selectedTime: ASAP_TIMING,
    };

    const newDateTimeObject = enableScheduleOrderFlag ? ScheduledDateTimeObj : dateTimeObject;
    let data = {
      id: storeId,
      summary: {
        menu: { catalogs: [catalog] },
      },
      addresses: [{ lang }],
    };
    const obj = await createBasketData(
      data,
      getDispositionTypeOnAPIFormat(serviceInfo),
      customerId,
      newDateTimeObject,
      getFullAddressDetails(address, true),
    );
    let currentTime = getCurrentDateTimeInUnix();
    if (enableScheduleOrderFlag && reorderDetails.selectedTime?.key < currentTime) {
      updateReorderDetails({
        hasError: {
          ...reorderDetails.hasError,
          error: true,
          errormessage: translateWithI18Next(TRANSLATE_MAPPING_KEY.SCHEDULE_ORDER_CA),
        },
      });
    } else {
      const scheduledDateInEpoch = isEmptyObject(reorderDetails.selectedTime) ? reorderDetails.selectedTime.key : '';
      console.log("scheduledDateInEpoch",scheduledDateInEpoch,reorderDetails.selectedTime.key)
      enableScheduleOrderFlag && sessionStorage.setItem(SESSION_STORAGE_KEYS.SCHEDULE_DATE_EPOCH, scheduledDateInEpoch);

      dispatch(
        createBasketsAction({
          data: obj,
          tenantId,
          successCallback: () => fetchReorderMenu(catalog, storeId, serviceInfo),
          errorCallback: () =>
            updateReorderDetails({
              storeClosedError: null,
              storeError: translateWithI18Next(STORE_CLOSED_ERROR)?.replace(
                '$storeName',
                `<b class="item-desc-bold">${storename}</b>`,
              ),
            }),
        }),
      );
    }
  };

  const setupLocalization = (storeInfo, orderInfo) => {
    const storeInfoData = _first(storeInfo, {});
    let { deliveryAddress, service: serviceInfo } = storeChanged ? getUpdatedPayloadInfo(storeInfo) : orderInfo;
    userOrderStateDispatch({
      type: DISPOSITION_METHOD,
      value: { dispositionType: serviceInfo },
    });
    const ScheduledDateTimeObj = {
      date: reorderDetails.selectedDate?.date?.key ?? formatDateTime(new Date(), YYYY_MM_DD),
      time: reorderDetails.selectedTime?.value ?? ASAP_TIMING,
      selectedTime: reorderDetails.selectedTime?.value ?? ASAP_TIMING,
    };
    const dateTimeObject = enableScheduleOrderFlag ? ScheduledDateTimeObj : dateTimeObj(storeInfoData);
    const isASAP = Boolean(dateTimeObject?.key === ASAP_TIMING);
    const dispositionInfo = {
      type: serviceInfo,
      store: storeInfoData,
      date: dateTimeObject?.date,
      time: dateTimeObject?.time,
      interval: dateTimeObject?.interval,
      selectedTime: dateTimeObject?.selectedTime,
      deliveryAddress: getFullAddressDetails(deliveryAddress, true),
      deliveryAddressLine: deliveryAddress?.addressLines?.length >= 1 ? deliveryAddress?.addressLines?.[0] : '',
    };
    userOrderStateDispatch({
      type: SET_DISPOSITION,
      value: {
        oldvalue: dispositionNew,
        newValue: dispositionInfo,
      },
    });
    localStorage.setItem(DISPOSITION_OLD, JSON.stringify(null));
    localStorage.setItem(DISPOSITION_NEW, JSON.stringify(dispositionInfo));
    localStorage.setItem(
      DISPOSITION_NEW,
      JSON.stringify({
        type: serviceInfo,
        store: storeInfoData,
        date: dateTimeObject?.date,
        time: dateTimeObject?.time,
        interval: dateTimeObject?.interval,
        selectedTime: dateTimeObject?.selectedTime,
        deliveryAddress: getFullAddressDetails(deliveryAddress, true),
        deliveryAddressLine: deliveryAddress?.addressLines?.length >= 1 ? deliveryAddress?.addressLines?.[0] : '',
      }),
    );

    userOrderStateDispatch({ type: SEARCH_ORDER_DATA, value: { showSearchStore: false } });
    userOrderStateDispatch({
      type: USER_LOCALIZED,
      value: { isLocalized: true },
    });
    userOrderStateDispatch({
      type: CURRENT_STORE_INFO,
      value: storeInfoData,
    });
    dispatch(
      setUserParams({
        ...userParams,
        localized: true,
      }),
    );

    localStorage.setItem(CURRENT_STORE_INFO_STORAGE, JSON.stringify(storeInfoData));
    localStorage.setItem(STORE_INFO, JSON.stringify(storeInfoData));
    if (enableScheduleOrderFlag) {
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SET_ORDER_NOW,
        value: { showOrderNow: false },
      });
      userOrderStateDispatch({
        type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER,
        value: { showScheduleOrder: true },
      });
      userOrderStateDispatch({
        type: SET_ASAP_SCHEDULING,
        value: { enableASAPScheduling: isASAP },
      });
    }

    userOrderStateDispatch({
      type: SCHEDULE_ORDER_TIME_DATA,
      value: { selectedDateTime: dateTimeObject },
    });
    localStorage.setItem(SELECTED_TILE, JSON.stringify({}));
    localStorage.setItem(CONFIG_SEARCH_SCREEN, FORM);
    localStorage.setItem(DISPOSITION_TYPE, serviceInfo);
    localStorage.setItem(DATE_TIME_ORDER, JSON.stringify(dateTimeObject));
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_ORDER_NOW_REORDER,
      value: { showOrderNowReorder: false },
    });
    userOrderStateDispatch({
      type: START_ORDER_CONSTANTS.SET_SCHEDULE_ORDER_REORDER,
      value: { showScheduleOrderReorder: false },
    });
    onClickOrderAgainHandler();
  };
  const successCallback = (storeInfo, orderInfo) => {
    const { modifiedStoreData } = getUpdatedStoreInfo(storeChanged, currentStoreInfo, currentOrderInfo);
    updateReorderDetails({
      showModal: true,
      orderinfoData: orderInfo,
      enableButton: true,
    });
    if (storeInfo.length) {
      const storeDetails = _first(storeInfo, {});
      const summary = _get(storeDetails, 'summary', {});
      const { currentStatus } = _get(summary, 'status', {});
      const storename = _get(summary, 'name', {});
      const isFutureTimeOrderAvailable = isFutureTime(storeDetails) || isFutureDate(storeDetails);
      if (currentStatus === CLOSED) {
        const setClosedStoreMsgPayload = {
          enableScheduleOrder,
          isFutureTimeOrderAvailable,
          updateReorderDetails,
          storename,
          service,
        };
        setStoreClosedErrorMessage(setClosedStoreMsgPayload);
      }
      if (userParams.localized) {
        if (safeUpperCase(dispositionNew?.type) !== safeUpperCase(service)) {
          const errorInfo = translateWithI18Next(ORDER_TYPE_DIFFERENT_ERROR)
            ?.replace('$previousOrderType', `<b class="item-desc-bold capitalize-text">${translateWithI18Next(service?.toLowerCase())}</b>`)
            .replace(
              '$currentOrderType',
              `<b class="item-desc-bold capitalize-text">${
                translateWithI18Next(dispositionNew?.type?.toLowerCase())
              }</b>`,
            );
          updateReorderDetails({ orderTypeDifferentError: errorInfo });
        }

        orderStoreId !== dispositionNew?.store?.id &&
          updateReorderDetails({ locationDifferentError: LOCATION_DIFFERENT_ERROR });
      }
    } else {
      updateReorderDetails({
        storeClosedError: null,
        storeError: translateWithI18Next(STORE_CLOSED_ERROR)?.replace(
          '$storeName',
          `<b class="item-desc-bold">${modifiedStoreData?.name}</b>`,
        ),
      });
    }
  };

  useEffect(() => {
    const { modifiedStoreId, modifiedStoreData, modifiedService: modifiedServiceInfo, modifiedDeliveryAddress } = getUpdatedStoreInfo(
      storeChanged,
      currentStoreInfo,
      currentOrderInfo,
    );
    dispatch(
      getStoreDetails(
        {
          storeId: modifiedStoreId,
          tenantId,
        },
        selectedStoreDetailsDL => {
          const statusCallPayload = {
            data: createPayloadForStatusCall(
              [modifiedStoreData],
              modifiedServiceInfo,
              modifiedDeliveryAddress,
              shouldCheckDropOffAddress,
            ),
            store: [{ ...selectedStoreDetailsDL, service: modifiedServiceInfo }],
            tenantId,
            setStatusFlag: false,
            isFavoritePage: false,
          };
          dispatch(
            getBulkStoreStatus(statusCallPayload, storeInfo => {
              updateReorderDetails({ storeDetail: storeInfo });
              dispatch(
                getPostOrderAccepted({ tenantId, orderId, customerId }, orderInfo =>
                  successCallback(storeInfo, orderInfo),
                ),
              );
            }),
          );
        },
      ),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {reorderDetails.showModal ? (
        <ReorderComponentGlobal
          {...props}
          onChangeDisposition={onChangeDisposition}
          editDeliveryLocation={editDeliveryLocation}
          onChangeRestaurant={onChangeRestaurant}
          onClickOrderAgain={onClickOrderAgain}
          storeError={getAndCheckIfOneTrue(reorderDetails.storeError, reorderDetails.locationDifferentError)}
          currencySymbol={currencySymbol}
          currencyConversionFactor={currencyConversionFactor}
          orderDetails={orderDetails}
          isPastOrderValidationLoading={isPastOrderValidationLoading}
          isAddItemLoading={isAddItemLoading}
          storeChanged={storeChanged}
          currentStoreInfo={currentStoreInfo}
          enableScheduleOrderFlag={enableScheduleOrderFlag}
          changeDateValue={changeDateValue}
          changeTimeValue={changeTimeValue}
          enableScheduleMode={enableScheduleMode}
          isStoreClosed={Boolean(reorderDetails.storeClosedError)}
          isGenericError={Boolean(reorderDetails.storeError)}
          {...reorderDetails}
        />
      ) : null}
    </>
  );
};

export default ReorderContainerGlobal;
